import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'

import { HelperWrapper, LocaleSelect, QRCode } from 'src/components'
import { OverrideButton } from './overrid-button.component'
import { ShareUploadIcon } from 'src/assets/icons'

import useStyles from './styles'
import { ProductCodeUrls } from './product-code-urls.component'
import { createProductQRLink } from 'src/common/utils'
import { useProductOverrideUrl } from 'src/hooks'

interface IQRCodeProps {
  title: string
  name: string
  code: string
  batchCode: string
  route: string
  productId: string
}

const QRCodePaper = (props: IQRCodeProps) => {
  const [, i18n] = useTranslation()
  const [lng, setLng] = useState(i18n.language)
  const { data: urlData } = useProductOverrideUrl(lng, props.productId)
  const navigate = useNavigate()
  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  useEffect(() => {
    if (!isTablet) {
      navigate(props.route)
    }
  })

  const handleShareClick = () => navigator.share && navigator.share({ url: window.location.href })

  const handleLocale = (lng: string) => {
    setLng(lng)
  }

  const qrLink = createProductQRLink({
    productId: props.productId,
    lng,
  })

  return (
    <div>
      <Grid className={`${classes.codeWrapper} ${classes.roundBorder}`} container>
        <div className={classes.localeWrapper}>
          <LocaleSelect handleLocale={handleLocale} locale={lng} />
        </div>
        <Typography className={classes.codeTitle} component="h2">
          {props.title}
        </Typography>
        <Grid>
          <Grid className={`${classes.codeImage} ${classes.roundBorder}`}>
            <QRCode qrLink={qrLink} />
          </Grid>
          <Grid className={classes.textWrapper}>
            <Typography className={classes.textTitle}>
              <HelperWrapper t="qr-code-name" />
            </Typography>
            <Typography className={classes.textValue}>{props.name}</Typography>
            <Typography className={classes.textTitle}>
              <HelperWrapper t="qr-code-code" />
            </Typography>
            <Typography className={classes.textValue}>{props.code}</Typography>
            <Typography className={classes.textTitle}>
              <HelperWrapper t="qr-code-batch-code" />
            </Typography>
            <Typography className={classes.textValue}>{props.batchCode}</Typography>
          </Grid>
        </Grid>
        <div className={classes.buttonsWrapper}>
          <OverrideButton
            url={urlData?.override_url || null}
            productId={props.productId}
            lngCode={lng}
          />
          <Button
            color="primary"
            variant="contained"
            startIcon={<ShareUploadIcon className={classes.buttonIcon} />}
            className={classes.button}
            onClick={handleShareClick}
          >
            <Typography className={classes.buttonText}>
              <HelperWrapper t="share-button-text" />
            </Typography>
          </Button>
        </div>
      </Grid>
      <div className={classes.urlsContainer}>
        <ProductCodeUrls qrLink={qrLink} overrideUrl={urlData?.override_url || null} />
      </div>
    </div>
  )
}

export { QRCodePaper }
